export const LOADING_SNACKBAR_TEXT = "Fetching your link...";
export const LINK_COPIED_SNACKBAR_TEXT = "Link copied.";

export enum ContentType {
    Post = 'post',
    Event = 'event'
}

export enum ShareContentMapType {
    PortalPost = 'portalPost',
    PortalPostPublic = 'portalPostPublic',
    PortalEvent = 'portalEvent',
    TeamsPost = 'teamsPost',
    TeamsEvent = 'teamsEvent',
    SharePointPost = 'sharePointPost',
    SharePointEvent = 'sharePointEvent',
    CustomShareLink = 'customShareLink'
}

export interface IShareLinkv1 {
    contentType: ShareContentMapType;
    contentId: string;
}